import { render, staticRenderFns } from "./CellSimple.vue?vue&type=template&id=064d5144"
import script from "./CellSimple.vue?vue&type=script&lang=js"
export * from "./CellSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports